/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumPlanObdobi } from '../model';
// @ts-ignore
import { PlanDetailVO } from '../model';
// @ts-ignore
import { PlanVO } from '../model';
// @ts-ignore
import { RozpoctovaSkladbaVO } from '../model';
/**
 * StromControllerApi - axios parameter creator
 * @export
 */
export const StromControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCestaKZaznamu: async (idPlan: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlan' is not null or undefined
            assertParamExists('getCestaKZaznamu', 'idPlan', idPlan)
            const localVarPath = `/api/rzpv/strom/cesta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlan !== undefined) {
                localVarQueryParameter['idPlan'] = idPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {number} idPlan 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMezirocniPrubeh: async (idObjekt: number, idPlan: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idObjekt' is not null or undefined
            assertParamExists('getMezirocniPrubeh', 'idObjekt', idObjekt)
            // verify required parameter 'idPlan' is not null or undefined
            assertParamExists('getMezirocniPrubeh', 'idPlan', idPlan)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('getMezirocniPrubeh', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/strom/mezirocniPrubeh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idObjekt !== undefined) {
                localVarQueryParameter['idObjekt'] = idObjekt;
            }

            if (idPlan !== undefined) {
                localVarQueryParameter['idPlan'] = idPlan;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMezirocniSrovnani: async (idObjekt: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idObjekt' is not null or undefined
            assertParamExists('getMezirocniSrovnani', 'idObjekt', idObjekt)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('getMezirocniSrovnani', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/strom/mezirocniSrovnani`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idObjekt !== undefined) {
                localVarQueryParameter['idObjekt'] = idObjekt;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrubehData: async (idPlan: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlan' is not null or undefined
            assertParamExists('getPrubehData', 'idPlan', idPlan)
            const localVarPath = `/api/rzpv/strom/prubeh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlan !== undefined) {
                localVarQueryParameter['idPlan'] = idPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRozpoctovaSkladba: async (idPlan: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlan' is not null or undefined
            assertParamExists('getRozpoctovaSkladba', 'idPlan', idPlan)
            const localVarPath = `/api/rzpv/strom/skladba`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlan !== undefined) {
                localVarQueryParameter['idPlan'] = idPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZaznamy: async (idPlanVerze: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('getZaznamy', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('getZaznamy', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/strom/vetve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StromControllerApi - functional programming interface
 * @export
 */
export const StromControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StromControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCestaKZaznamu(idPlan: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCestaKZaznamu(idPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {number} idPlan 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMezirocniPrubeh(idObjekt: number, idPlan: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<ChartPrubeh>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMezirocniPrubeh(idObjekt, idPlan, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMezirocniSrovnani(idObjekt: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: PlanVO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMezirocniSrovnani(idObjekt, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrubehData(idPlan: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDetailVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrubehData(idPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRozpoctovaSkladba(idPlan: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RozpoctovaSkladbaVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRozpoctovaSkladba(idPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZaznamy(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZaznamy(idPlanVerze, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StromControllerApi - factory interface
 * @export
 */
export const StromControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StromControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCestaKZaznamu(idPlan: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getCestaKZaznamu(idPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {number} idPlan 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMezirocniPrubeh(idObjekt: number, idPlan: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<{ [key: string]: Array<ChartPrubeh>; }> {
            return localVarFp.getMezirocniPrubeh(idObjekt, idPlan, planObdobi, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idObjekt 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMezirocniSrovnani(idObjekt: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<{ [key: string]: PlanVO; }> {
            return localVarFp.getMezirocniSrovnani(idObjekt, planObdobi, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrubehData(idPlan: number, options?: any): AxiosPromise<Array<PlanDetailVO>> {
            return localVarFp.getPrubehData(idPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRozpoctovaSkladba(idPlan: number, options?: any): AxiosPromise<RozpoctovaSkladbaVO> {
            return localVarFp.getRozpoctovaSkladba(idPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZaznamy(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>> {
            return localVarFp.getZaznamy(idPlanVerze, planObdobi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StromControllerApi - interface
 * @export
 * @interface StromControllerApi
 */
export interface StromControllerApiInterface {
    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getCestaKZaznamu(idPlan: number, options?: any): AxiosPromise<Array<number>>;

    /**
     * 
     * @param {number} idObjekt 
     * @param {number} idPlan 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getMezirocniPrubeh(idObjekt: number, idPlan: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<{ [key: string]: Array<ChartPrubeh>; }>;

    /**
     * 
     * @param {number} idObjekt 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getMezirocniSrovnani(idObjekt: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<{ [key: string]: PlanVO; }>;

    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getPrubehData(idPlan: number, options?: any): AxiosPromise<Array<PlanDetailVO>>;

    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getRozpoctovaSkladba(idPlan: number, options?: any): AxiosPromise<RozpoctovaSkladbaVO>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApiInterface
     */
    getZaznamy(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<PlanVO>>;

}

/**
 * StromControllerApi - object-oriented interface
 * @export
 * @class StromControllerApi
 * @extends {BaseAPI}
 */
export class StromControllerApi extends BaseAPI implements StromControllerApiInterface {
    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getCestaKZaznamu(idPlan: number, options?: any) {
        return StromControllerApiFp(this.configuration).getCestaKZaznamu(idPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idObjekt 
     * @param {number} idPlan 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getMezirocniPrubeh(idObjekt: number, idPlan: number, planObdobi: EnumPlanObdobi, options?: any) {
        return StromControllerApiFp(this.configuration).getMezirocniPrubeh(idObjekt, idPlan, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idObjekt 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getMezirocniSrovnani(idObjekt: number, planObdobi: EnumPlanObdobi, options?: any) {
        return StromControllerApiFp(this.configuration).getMezirocniSrovnani(idObjekt, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getPrubehData(idPlan: number, options?: any) {
        return StromControllerApiFp(this.configuration).getPrubehData(idPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getRozpoctovaSkladba(idPlan: number, options?: any) {
        return StromControllerApiFp(this.configuration).getRozpoctovaSkladba(idPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StromControllerApi
     */
    public getZaznamy(idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any) {
        return StromControllerApiFp(this.configuration).getZaznamy(idPlanVerze, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }
}
